module.exports = __webpack_public_path__ + "static/media/register-icon.7692576f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/register-icon.png
// module id = 203
// module chunks = 0